import { z } from 'zod';
import { userDirectoryGetRequestParamsSchema } from './types';
export const userDirectoryGetDef = {
    name: 'userDirectoryGet',
    requestSchema: userDirectoryGetRequestParamsSchema,
    responseSchema: z.unknown(),
};
